import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SupportCategory } from 'SupportApp/interfaces/support-category.interface';
import { SupportContent } from 'SupportApp/interfaces/support-content.interface';

@Component({ standalone: false, selector: 'ycn-support-sidebar', templateUrl: './support-sidebar.template.html' })
export class SupportSidebarComponent {
    @Input() selectedCategory!: SupportCategory;

    @Input() selectedContentId!: number;

    @Input() categories: SupportCategory[] = [];

    @Output() selectedCategoryChange = new EventEmitter<SupportCategory>();

    @Output() selectedContentIdChange = new EventEmitter<number>();

    handleCategoryClick(category: SupportCategory): void {
        this.selectedCategory = category;
        this.selectedCategoryChange.emit(this.selectedCategory);
        window.location.hash = category.internal_name ? category.internal_name : '';
    }

    handleContentClick(contentId: number): void {
        this.selectedContentId = contentId;
        this.selectedContentIdChange.emit(this.selectedContentId);
    }

    isRedirect(item: SupportCategory | SupportContent): boolean {
        return item.redirect_url !== null && item.redirect_url.length > 0;
    }
}
